import { render, staticRenderFns } from "./OrganizationFields.vue?vue&type=template&id=51dcc329&scoped=true&"
import script from "./OrganizationFields.vue?vue&type=script&lang=js&"
export * from "./OrganizationFields.vue?vue&type=script&lang=js&"
import style0 from "./OrganizationFields.vue?vue&type=style&index=0&id=51dcc329&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51dcc329",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCheckbox,VCol,VRow})
